import React, { useState, useEffect, useRef } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  TextField,
  IconButton,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { SaveAlt } from "@material-ui/icons";
import HttpService from "../../services/httpService";
import moment from "moment";
import { ROLENAME } from "../../utils";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 1000,
    width: "100%",
    borderCollapse: "collapse",
  },
  paper: {
    padding: theme.spacing(3),
    margin: theme.spacing(2, 0),
    width: "100%",
    overflowX: "auto",
  },
  titleContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    textAlign: "center",
  },
  titleText: {
    margin: 0,
    fontWeight: "bold",
    fontSize: "1.5rem",
    color: "#1C375D",
  },
  buttonGroup: {
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "center",
  },
  approveBtn: {
    backgroundColor: "#4CAF50",
    color: "white",
    padding: "6px 12px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#388E3C",
    },
  },
  rejectBtn: {
    backgroundColor: "#F44336",
    color: "white",
    padding: "6px 12px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#D32F2F",
    },
  },
  bottomActions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1),
  },
}));

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: "#1C375D",
    color: "#FFF",
    fontWeight: 600,
    textAlign: "center",
  },
  body: {
    fontSize: 14,
    borderRight: "1px solid #ccc",
    textAlign: "center",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const CommitmentApprovalForADM = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  const [openAlertModel, setOpenAlertModel] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [activeTab, setActiveTab] = useState("commitment");
  const [clicked, setClicked] = useState(false); 

  useEffect(() => {
    getApprovalData();
  }, [activeTab]);


  // useEffect(() => {
  //  getApprovalData();
  // }, []);


  const getApprovalData = async () => {
        props.setLoading(true);
        try {
            let userRoles = userDetails?.roles.map((el) => el._id);
            let userExpeData = userDetails?.experienceCenterId?.map((el) => el);


            const obj = {
              userId: userDetails._id,
              userRole: userRoles || [],
              userExpeCenterId: userExpeData || [],
              pivot: activeTab,
            }
            let response = await HttpService.getAdmDSoApprovalData(obj);
              
            if (response?.status === 200) {
                const { data } = response;
                if (data) {
                    setData(data);
                    props.setSnackInfo("Data Fetched Successfully", "success");
                } else {
                    setData([]);
                    props.setSnackInfo("No Data Found", "info");
                }
            } else {
                const errMsg =
                    response?.data?.message || "Failed to Fetch Data";
                props.setSnackInfo(errMsg, "error");
            }
        } catch (error) {
            console.error("Error fetching Bottoms Up Data:", error);

            // Extract detailed error message if available
            let message = "Something went wrong!";
            if (error?.response?.data?.message) {
                message = error.response.data.message;
            } else if (error?.message) {
                message = error.message;
            }

            props.setSnackInfo(message, "error");
        } finally {
            props.setLoading(false);
        }
  };

  const handleExportCSV = () => {
    const headers = [
      "Sl. No.",
      "Project No",
      "Lead No",
      "Value(INR)",
      "City",
      "Exp Ctr. Name",
      "Sales Won Date",
      "Tentative Design Closure Date (Committed Date)",
      "DSO Month change Approvals Date",
    ];
    const rows = data.map((row, i) => [
      i + 1,
      row?.erpProjectNo || "N/A",
      row?.lead_no,
      row?.staticSalesWonBudget,
      row?.cityName || "N/A",
      row?.experienceCenterName || "N/A",
      row?.leadWonDate
                  ? moment(row?.leadWonDate).format("DD-MM-YYYY")
                  : "-",
      row?.closureDate
                  ? moment(row?.closureDate).format("DD-MM-YYYY")
                  : "-",
      row?.designHealthSecondApprovalsDate
                  ? moment(row?.designHealthSecondApprovalsDate).format("DD-MM-YYYY")
                  : "-",
    ]);
    const csvContent = [headers, ...rows].map(r => r.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = activeTab === "commitment" ? "new_commitment_approval.csv" : "month_change_approval.csv"
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(+e.target.value);
    setPage(0);
  };

  // this is new committed month data save API.
  const newCommitmentApproveOrReject = async (leadId, stage) => {
      props.setLoading(true);
      try {
          let userRoles = userDetails?.roles.map((el) => el._id);
          let userExpeData = userDetails?.experienceCenterId?.map((el) => el);

          if (!leadId || !stage) {
              props.setSnackInfo("Lead ID and Stage are required", "error");
              return;
          }
          if (!userRoles || userRoles.length === 0) {
              props.setSnackInfo("User roles are required", "error");
              return;
          }
          if (!userExpeData || userExpeData.length === 0) {
              props.setSnackInfo("User experience center data is required", "error");
              return;
          }
          
          setClicked(true); 

          const obj = {
            userId: userDetails._id,
            userRole: userRoles || [],
            userExpeCenterId: userExpeData || [],
            leadId: leadId,
            stage: stage,
            activeTab: activeTab,
          }

          const response = await HttpService.approveOrRejectDSOProjection(
              obj
          );
          if (response?.status === 201) {
              const { data } = response;
              if (data) {
                setClicked(false); 
                setData([]);
                getApprovalData();
                props.setSnackInfo(data?.message, "success");
              } else {
                props.setSnackInfo("Nothing Happen Anything.", "info");
              }
          } else {
              const errMsg =
                  response?.data?.message || "somthing problem while leads freezing";
              props.setSnackInfo(errMsg, "error");
          }
          
      } catch (error) {
          console.error("Error while freezing leads:", error);
          let message = "Something went wrong!";
          if (error?.response?.data?.message) {
              message = error.response.data.message;
          }
          props.setSnackInfo(message, "error");
      }
      props.setLoading(false);
  }

  return (
    <div style={{ width: "100%", padding: "0 16px" }}>
      <Grid container>
        <Grid item xs={12} className={classes.titleContainer}>
          <h2 className={classes.titleText}>
            Projection Commitment Approval Dashboard
          </h2>
        </Grid>

        <Grid item xs={12}>
          <Paper className={classes.paper} elevation={3}>
            <TableContainer>
              <div style={{ marginBottom: "16px", display: "flex", gap: "12px" }}>
                <Button
                  variant={activeTab === "commitment" ? "contained" : "outlined"}
                  color="primary"
                  onClick={() => {
                    setActiveTab("commitment");
                    setPage(0);
                    setData([]);
                  }}
                  sx={{
                    borderRadius: 0,
                    fontWeight: "bold",
                    textTransform: "none",
                    padding: "10px 20px",
                    minWidth: "200px",
                    boxShadow: activeTab === "commitment" ? 3 : 0,
                  }}
                >
                  New Commitment Approval
                </Button>

                <Button
                  variant={activeTab === "monthChange" ? "contained" : "outlined"}
                  color="secondary"
                  onClick={() => {
                    setActiveTab("monthChange");
                    setPage(0);
                    setData([]);
                  }}
                  sx={{
                    borderRadius: 0,
                    fontWeight: "bold",
                    textTransform: "none",
                    padding: "10px 20px",
                    minWidth: "200px",
                    boxShadow: activeTab === "monthChange" ? 3 : 0,
                  }}
                >
                  Month Change Approval
                </Button>
              </div>
              <Table className={classes.table} size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sl. No.</StyledTableCell>
                    <StyledTableCell>Project No</StyledTableCell>
                    <StyledTableCell>Lead No</StyledTableCell>
                    <StyledTableCell>Design User</StyledTableCell>
                    <StyledTableCell>Value(INR)</StyledTableCell>
                    <StyledTableCell>Exp Ctr. Name</StyledTableCell>
                    <StyledTableCell>Sales Won Date</StyledTableCell>
                    <StyledTableCell>Tentative Design Closure Date (Committed Date)</StyledTableCell>
                    {activeTab === "monthChange" && <StyledTableCell>DSO Month Change (Slip on)</StyledTableCell>}
                    <StyledTableCell>ODM Status</StyledTableCell>
                    <StyledTableCell>DGM Status</StyledTableCell>
                    {userDetails?.roles?.find(
                      role =>
                        role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.DGM_Design || role.name === ROLENAME.AGM_Design
                      ) &&
                      <>
                      <StyledTableCell>Action</StyledTableCell> 
                      </>
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, i) => (
                      <StyledTableRow key={row?._id || i}>
                        <StyledTableCell>{page * rowsPerPage + i + 1}</StyledTableCell> 
                        <StyledTableCell>
                            {row?.erpProjectNo && row._id ? (
                                <a
                                    href={`/project-logs/${row._id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color: "rgba(0, 0, 0, 0.87)",
                                        textDecoration: "underline",
                                    }}
                                >
                                    {row.erpProjectNo}
                                </a>
                            ) : (
                                row?.erpProjectNo || "NA"
                            )}
                        </StyledTableCell>
                        <StyledTableCell>
                            {row?.lead_no && row._id ? (
                                <a
                                    href={`/project-logs/${row._id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color: "rgba(0, 0, 0, 0.87)",
                                        textDecoration: "underline",
                                    }}
                                >
                                    {row.lead_no}
                                </a>
                            ) : (
                                row?.lead_no || "NA"
                            )}
                        </StyledTableCell>
                        <StyledTableCell>{row?.designUser?.name}</StyledTableCell>
                        <StyledTableCell>{row?.staticSalesWonBudget}</StyledTableCell>
                        <StyledTableCell>{row?.experienceCenterName}</StyledTableCell>
                        <StyledTableCell>{moment(row?.leadWonDate).format("DD-MM-YYYY")}</StyledTableCell>
                        <StyledTableCell>
                          {row?.closureDate
                            ? moment(row.closureDate).format("DD-MM-YYYY")
                            : "N/A"}
                        </StyledTableCell>
                        {activeTab === "monthChange" && <StyledTableCell>
                          {moment(row?.designHealthSecondApprovalsDate).format("DD-MM-YYYY")}
                        </StyledTableCell>}
                        <StyledTableCell>
                          {
                            (
                              row?.designHealthFirstApprovals === "Approved by ODM" ||
                              row?.designHealthSecondApprovals === "Approved by ODM" ||
                              row?.designHealthFirstApprovals === "Rejected by AGM/DGM" ||
                              row?.designHealthSecondApprovals === "Rejected by AGM/DGM"
                            )
                              ? "Approved"
                              : "Pending"
                          }
                        </StyledTableCell>
                        <StyledTableCell>
                            {(row?.designHealthFirstApprovals === "Rejected by AGM/DGM" || 
                            row?.designHealthSecondApprovals === "Rejected by AGM/DGM") 
                              ? "Rejected by AGM/DGM"
                              :(row?.designHealthFirstApprovals === "Approved by ODM" || 
                              row?.designHealthSecondApprovals === "Approved by ODM")
                              ? "Pending"
                              : "N/A"
                          }
                        </StyledTableCell>

                        {userDetails?.roles?.find(
                            role =>
                              role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.DGM_Design || role.name === ROLENAME.AGM_Design
                            ) &&
                          <>
                            <StyledTableCell>
                              <div className={classes.buttonGroup}>
                                <button
                                  type="button"
                                  variant="contained"
                                  className={classes.approveBtn}
                                  disabled={ clicked} 
                                  onClick={() => newCommitmentApproveOrReject(row?._id, "Approved")}
                                >
                                  Approve
                                </button>
                                <button
                                  type="button"
                                  variant="contained"
                                  className={classes.rejectBtn}
                                  disabled={ clicked} 
                                  onClick={() => newCommitmentApproveOrReject(row?._id, "Rejected")}
                                >
                                  Reject
                                </button>
                              </div>
                            </StyledTableCell>
                          </>
                        }
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            <div className={classes.bottomActions}>
              <IconButton onClick={handleExportCSV} color="primary" title="Export as CSV">
                <SaveAlt />
              </IconButton>
              <TablePagination
                component="div"
                count={data.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </Paper>
        </Grid>
      </Grid>

      <Dialog
        open={openAlertModel}
        onClose={() => setOpenAlertModel(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <DialogContentText>Enter remarks for this action</DialogContentText>
          <TextField autoFocus margin="dense" label="Remarks" type="text" fullWidth variant="outlined" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAlertModel(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={() => setOpenAlertModel(false)} color="primary" variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(CommitmentApprovalForADM);